<script>
import core from '@/utils/mixin-core'

export default {
  mixins: [core],
  name: 'connection-check',
  data() {
    return {
      status: true,
      interval: null,
      intervalFailure: null,
      notify: null,
    }
  },
  methods: {
    setStatus() {
      this.$CORE.socket.emit('connectionCheck', {id: this.$CORE.socket.id})
      clearInterval(this.intervalFailure)
      this.intervalFailure = setTimeout(() => {
        this.status = false
      }, this.status ? this.$CORE.env.socket.healthCheckInterval /2 : this.$CORE.env.socket.healthCheckRetryInterval /2)
    },
    getStatus() {
      this.$CORE.socket.on('connectionCheck', (data) => {
        this.status = !!data
        clearInterval(this.intervalFailure)
      })
    },
    setInterval() {
      this.interval = setInterval(() => {
        this.setStatus()
      }, this.status ? this.$CORE.env.socket.healthCheckInterval : this.$CORE.env.socket.healthCheckRetryInterval)
    },
    clearInterval() {
      clearInterval(this.interval)
    }
  },
  watch: {
    status(newValue, oldValue) {
      if (newValue === false) {
        this.$notify({
          title: 'connection_error_title',
          type: 'error',
          duration: 3000,
          position: 'bottom-right',
          showClose: false,
          customClass: 'title-patch'
        })

        setTimeout(() => {
          this.notify = this.$notify({
            title: 'reconnecting_title',
            message: 'Connection to server is lost. Trying to reconnect...',
            iconClass: 'el-icon-loading',
            position: 'bottom-right',
            duration: 0,
            showClose: false,
            customClass: 'title-patch'
          })
        }, 500);
      } else {
        this.notify && this.notify.close()

        this.$notify({
          title: 'connection_restored_title',
          type: 'success',
          duration: 3000,
          position: 'bottom-right',
          showClose: false,
          customClass: 'title-patch'
        })
        clearInterval(this.intervalFailure)
      }

      this.clearInterval()
      this.setInterval()
    }
  },
  render(h) {
    return h()
  },
  mounted() {
    if (this.$CORE.socket) {
      this.setInterval()
      this.getStatus()
    }
  },
  unmounted() {
    this.clearInterval()
  }
}
</script>

<style>
.title-patch .el-notification__title {
  padding-top: 3px;
}
</style>